// src/hooks/useSchoolBrand.js
import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

// Module-level shared state — persists across re-renders but resets on refresh
let _brand = { name: '', logo: '' };
let _fetching = false;
let _listeners = new Set();

// Call this to push new brand to all mounted sidebars
const notifyAll = () => {
  _listeners.forEach(fn => fn({ ..._brand }));
};

// Fetch brand from server and notify all listeners
const doFetch = () => {
  if (_fetching) return;
  _fetching = true;
  api.get('/settings/brand?_=' + Date.now())
    .then(({ data }) => {
      _brand = { name: data.name || '', logo: data.logo || '' };
      _fetching = false;
      notifyAll();
    })
    .catch(() => {
      _fetching = false;
    });
};

// Reset cache — call this on logout so next login gets fresh data
export const resetSchoolBrand = () => {
  _brand = { name: '', logo: '' };
  _fetching = false;
  notifyAll();
};

export const useSchoolBrand = () => {
  const [brand, setBrand] = useState({ ..._brand });

  useEffect(() => {
    // Register listener
    const listener = (newBrand) => setBrand({ ...newBrand });
    _listeners.add(listener);

    // Always fetch fresh on mount — don't rely on stale cache
    doFetch();

    return () => {
      _listeners.delete(listener);
    };
  }, []);

  const refreshBrand = useCallback(() => {
    _brand = { name: '', logo: '' };
    _fetching = false;
    doFetch();
  }, []);

  return { brand, refreshBrand };
};